/**
 * API endpoint resolution. Priority: `?api=` URL param, then `VITE_API_URL`, then the page's
 * host on port 8787 (the dev API).
 */
const params = new URLSearchParams(location.search);

function normalize(raw: string): string {
  let url = raw.trim();
  if (!/^https?:\/\//i.test(url)) url = `http://${url}`;
  return url.replace(/\/+$/, '');
}

function resolveBase(): string {
  const fromParam = params.get('api');
  if (fromParam) return normalize(fromParam);
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  if (fromEnv) return normalize(fromEnv);
  const proto = location.protocol === 'https:' ? 'https' : 'http';
  return `${proto}://${location.hostname || 'localhost'}:8787`;
}

export const API_BASE = resolveBase();
export const WS_BASE = API_BASE.replace(/^http/i, 'ws');
